import { IApiResponse } from "../../../@types/api-response.type"
import { IAddCurriculumDto, IGetCurriculumDto, ILinkedinSyncStatusDto } from "../../../@types/curriculum.type"
import { Api } from "../ApiConfig"
import { ApiException } from "../ApiException"
import { getErrorMessage } from "../../../utils/utils"


export const getCurriculumByResourceId = async (id: string): Promise<IGetCurriculumDto> => {
  try {
    const { data } = await Api.get<IApiResponse<IGetCurriculumDto>>(`/api/Curriculum/GetByResourceId/${id}`)
    return data.result
  } catch (error) {
    throw new ApiException(getErrorMessage(error, 'Erro ao consultar Currículo por Colaborador'))
  }
}

export const addOrUpdateCurriculum = async (curriculum: IAddCurriculumDto) => {
  try {
    const { data } = await Api.post('/api/Curriculum/AddOrUpdateCurriculum', curriculum);
    return data;

  } catch (error) {
    const message = 'Erro ao criar ou atualizar Currículo';
    throw new ApiException(getErrorMessage(error, message));
  }
}

export const updateLinkedinSyncStatus = async (linkedin: ILinkedinSyncStatusDto) => {
  try {
    const { data } = await Api.post('/api/Curriculum/UpdateLinkedinSyncStatus', linkedin);
    return data;

  } catch (error) {
    throw new ApiException(getErrorMessage(error, 'Erro ao sincronizar Linkedin'));
  }

}